export const draggable = {
  bind(el: HTMLElement): void {
    const dragHandle = el.querySelector('.drag-handle') || el;
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let initialX = 0;
    let initialY = 0;

    const init = () => {
      const rect = el.getBoundingClientRect();
      initialX = rect.left;
      initialY = rect.top;

      el.style.position = 'fixed';
      el.style.zIndex = '1000';
      el.style.left = `${initialX}px`;
      el.style.top = `${initialY}px`;
    };
    setTimeout(() => {
      init();
    });

    dragHandle.addEventListener('mousedown', (e: MouseEvent) => {
      isDragging = true;
      startX = e.clientX;
      startY = e.clientY;

      const rect = el.getBoundingClientRect();
      initialX = rect.left;
      initialY = rect.top;

      el.style.position = 'fixed';
      el.style.zIndex = '1000';
      (dragHandle as HTMLElement).style.cursor = 'move';

      e.preventDefault();
    });

    document.addEventListener('mousemove', (e: MouseEvent) => {
      if (!isDragging) return;

      const deltaX = e.clientX - startX;
      const deltaY = e.clientY - startY;

      el.style.left = `${initialX + deltaX}px`;
      el.style.top = `${initialY + deltaY}px`;
    });

    document.addEventListener('mouseup', () => {
      if (isDragging) {
        isDragging = false;
        (dragHandle as HTMLElement).style.cursor = '';
      }
    });
  },
};
